<template>
  <v-app class="dashboard">
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style lang="css">
.theme--light.v-application {
  background: #EAEFF0 !important;
}
</style>
